import { InitSE, InitSEParams, SEBundle, SEStore, SubinitSE, SubinitSEParams, TFEvents } from '../types/types'
import { presets } from 'tf-se-core'
const { v1: Se } = presets



const initSE: InitSE = (initSEParams: InitSEParams): SubinitSE => {
    const bundle: SEBundle = initSEParams.bundle
    const events: TFEvents = initSEParams.events

    const subInitSE: SubinitSE = (subinitSEParams: SubinitSEParams) => {
        const id: string = subinitSEParams.id
        const engineId: string = subinitSEParams.engineId
        const requestOptions: any = subinitSEParams.requestOptions
        const fields: { [key: string]: any }[] = subinitSEParams.fields
        const fieldCounters: string[] = subinitSEParams.fieldCounters
        const criteriaCounters: string[] = subinitSEParams.criteriaCounters
        const adultAge: number = subinitSEParams.adultAge

        events.onceAll(
            ['store'],
            async () => {
                const se: any = await Se({
                    id,
                    engineId,
                    type: 'counters',
                    requestOptions,
                    fields,
                    fieldCounters,
                    criteriaCounters,
                    adultAge,
                    syncUrl: false
                })
                // request
                // se.requestGeoDataWithEngineId()
                // se.request()

                se.on(se.events.FILTERS, () => se.request())

                const store: SEStore | null = bundle.store
                if (!store) throw new Error("store cannot be null")
                store.libs.se = se

                store.getCapacityById = function (capacityId: string) {
                    var capacity = store.data.fields.capacity.find(function (value: { [key: string]: any }) {
                        return value.id === capacityId
                    })
                    return capacity
                }

                se.once(
                    se.events.AFTER_MAP_REQUEST,
                    function () {
                        var geoData = se.getGeoData()
                        // regions
                        geoData.regionsMap = {}
                        geoData.regions.forEach(function (region: { [key: string]: any }) {
                            geoData.regionsMap[region.id] = region
                        })
                        // domains
                        geoData.domainsMap = {}
                        geoData.domains = geoData.domaines || geoData.domains
                        delete geoData.domaines
                        geoData.domains.forEach(function (domain: { [key: string]: any }) {
                            geoData.domainsMap[domain.id] = domain
                        })
                        // parent stations
                        geoData.parentStationsMap = {}
                        geoData.parentStations.forEach(function (parentStation: { [key: string]: any }) {
                            geoData.parentStationsMap[parentStation.id] = parentStation
                        })
                        // stations
                        geoData.stationsMap = {}
                        geoData.stations.forEach(function (station: { [key: string]: any }) {
                            geoData.stationsMap[station.id] = station
                        })
                        store.data.geoData = geoData
                    },
                    true
                )

                se.onAvailableFieldValues(
                    `region`,
                    function () {
                        var regions = se.getAvailableFieldValues('region')
                        var regionsMap: { [key: string]: any } = {}
                        regions.forEach(function (regionId: string) {
                            regionsMap[regionId] = true
                        })
                        store.data.available.regions = regions
                        store.data.available.regionsMap = regionsMap
                    },
                    true
                )

                se.onAvailableFieldValues(
                    'domaineSki',
                    function () {
                        var domains = se.getAvailableFieldValues('domaineSki')
                        var domainsMap: { [key: string]: any } = {}
                        domains.forEach(function (domainId: string) {
                            domainsMap[domainId] = true
                        })
                        store.data.available.domains = domains
                        store.data.available.domainsMap = domainsMap
                    },
                    true
                )

                se.onAvailableFieldValues(
                    'parentStation',
                    function () {
                        var parentStations = se.getAvailableFieldValues('parentStation')
                        var parentStationsMap: { [key: string]: any } = {}
                        parentStations.forEach(function (parentStationId: string) {
                            parentStationsMap[parentStationId] = true
                        })
                        store.data.available.parentStations = parentStations
                        store.data.available.parentStationsMap = parentStationsMap
                    },
                    true
                )

                se.onAvailableFieldValues(
                    'station',
                    function () {
                        var stations = se.getAvailableFieldValues('station')
                        var stationsMap: { [key: string]: any } = {}
                        stations.forEach(function (stationId: string) {
                            stationsMap[stationId] = true
                        })
                        store.data.available.stations = stations
                        store.data.available.stationsMap = stationsMap
                    },
                    true
                )

                se.onFieldValue(
                    'region',
                    function () {
                        var region = se.getFieldValue('region') || null
                        store.data.selected.region = region
                    },
                    true
                )

                se.onFieldValue(
                    'domaineSki',
                    function () {
                        const domain = se.getFieldValue('domaineSki') || null
                        store.data.selected.domain = domain
                    },
                    true
                )

                se.onFieldValue(
                    'parentStation',
                    function () {
                        const parentStations = se.getFieldValue('parentStation') || null
                        const parentStationsMap: { [key: string]: any } = {}
                            ; (parentStations || []).forEach(function (parentStationId: string) {
                                parentStationsMap[parentStationId] = true
                            })
                        store.data.selected.parentStations = parentStations
                        store.data.selected.parentStationsMap = parentStationsMap
                    },
                    true
                )

                se.onFieldValue(
                    'station',
                    function () {
                        const stations = se.getFieldValue('station') || null
                        const stationsMap: { [key: string]: any } = {}
                            ; (stations || []).forEach(function (stationId: string) {
                                stationsMap[stationId] = true
                            })
                        store.data.selected.stations = stations
                        store.data.selected.stationsMap = stationsMap
                    },
                    true
                )

                se.onAvailableFieldValues(
                    'capacity',
                    function () {
                        const capacity: any = se.getAvailableFieldValues('capacity')
                        capacity.sort((a: string, b: string) => {
                            const ca = store.getCapacityById(a)
                            const cb = store.getCapacityById(b)
                            return ca.value - cb.value
                        })
                        const capacityMap: { [key: string]: any } = {}
                        capacity.forEach(function (capacityId: string) {
                            capacityMap[capacityId] = true
                        })

                        store.data.available.capacity = capacity
                        store.data.available.capacityMap = capacityMap
                    },
                    true
                )

                se.onFieldValue(
                    'beginDate',
                    function () {
                        const dateStr: string = se.getFieldValue('beginDate')
                        store.data.selected.startDate = dateStr ? new Date(dateStr) : null
                    },
                    true
                )

                se.onFieldValue(
                    'endDate',
                    function () {
                        const dateStr: string = se.getFieldValue('endDate')
                        store.data.selected.endDate = dateStr ? new Date(dateStr) : null
                    },
                    true
                )

                se.onFieldValue(
                    'capacity',
                    function () {
                        store.data.selected.capacity = se.getFieldValue('capacity')
                    },
                    true
                )

                se.on(
                    se.events.BEFORE_REQUEST,
                    () => {
                        store.state.loading = true
                    },
                    true
                )

                se.on(
                    se.events.AFTER_REQUEST,
                    () => {
                        if (se.getRequestsInProgressNum() === 0) {
                            store.state.loading = false
                        }
                    },
                    true
                )

                se.on(
                    se.events.COUNTERS,
                    () => {
                        store.state.updateCounters++
                    },
                    true
                )

                se.on(
                    se.events.FILTERS,
                    () => {
                        store.state.updateFilters++
                    },
                    true
                )

                events.fire('libs.se')
            },
            true
        )
    }
    return subInitSE
}
export default initSE
